export type IUserProfile = 'manager' | 'tutor' | 'master' | 'student' | 'guardian' | 'trainer' | 'educators'
